import { useQuery } from '@hooks/reactQuery';

import { getCrowdCellConfig } from '@api/manageCrowdCells';

import { extractQueryParams } from '@utils/common';

import { IGetCrowdCellConfigDTO } from '@interfaces/crowdcell/dto/crowdCellsDTO';

import { CROWDCELLS_CONFIG_DATA } from '@constants/queryKeys';

export const useQueryCrowdCellConfig = (params?: IGetCrowdCellConfigDTO) => {
	const {
		crowdCellId,
		timestamp,
	} = params || {};

	const {
		isFetching: isFetchingCrowdCellConfig,
		isLoading: isLoadingCrowdCellConfig,
		data: crowdCellConfig,
		isInitialLoading: isInitialLoadingCrowdCellConfig,
	} = useQuery({
		queryKey: [
			CROWDCELLS_CONFIG_DATA,
			params,
		],
		queryFn: extractQueryParams(getCrowdCellConfig),
		enabled: [crowdCellId, timestamp],
		refetchOnWindowFocus: false,
	});

	return {
		crowdCellConfig: crowdCellConfig || null,
		isFetchingCrowdCellConfig,
		isLoadingCrowdCellConfig,
		isInitialLoadingCrowdCellConfig,
	};
};
